import { render, staticRenderFns } from "./addContacts.vue?vue&type=template&id=cd03631e&"
import script from "./addContacts.vue?vue&type=script&lang=js&"
export * from "./addContacts.vue?vue&type=script&lang=js&"
import style0 from "./addContacts.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports